import { Dropdown, IconButton } from '@blend-ed/blendx-ui';
import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage';

function LanguageSelector() {

  const { availableLanguages, changeLanguage, locale } = useLanguage();

  const handleLanguageChange = async (selectedLanguage) => {
    try {
      await changeLanguage(selectedLanguage);
    } catch (error) {
      console.error(error);
    }
    // reload the page
    window.location.reload();
  };

  return (
    <Dropdown
      size="xs"
      placeholder={'Language'}
      menuPosition="left"
      onClick={(e) => handleLanguageChange(e.value)}
      selected={locale}
      toggle={
        <IconButton
          variant="ghost-gray"
          icon="global"
          iconType="line"
        />
      }
    >
      {availableLanguages.filter((language) => language.released).map((language) => (
        <Dropdown.Item
          key={language.code}
          label={language.name}
          value={language.code}
        />
      ))}
    </Dropdown>
  );
}

export default LanguageSelector; 